import { BaseRestDataProvider } from './BaseRestDataProvider';
import { Contact } from '../models/Contact';

export class ContactRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/contacts');
  }

  getAll(): Promise<Contact[]> {
    return this.get<Contact[]>(``);
  }

  getByParentId(parentId: string): Promise<Contact[]> {
    return this.get<Contact[]>(`?parentId=${parentId}`);
  }

  getById(id: string): Promise<Contact> {
    return this.get<Contact>(`/${id}`);
  }

  add(contact: Contact): Promise<Contact> {
    return this.post<Contact>(``, contact);
  }

  update(id: string, contact: Contact): Promise<void> {
    return this.put<void>(`/${id}`, contact);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }
}

export type { Contact };
